// importados
import vSelect from 'vue-select';
import draggable from 'vuedraggable';
// https://github.com/phoenixwong/vue2-timepicker
import VueTimepicker from 'vue2-timepicker';
// https://github.com/Belphemur/vue-json-csv
import JsonCSV from 'vue-json-csv';

// locais
import vMoney from '@/components/shared/form/VerifiedMoney.vue';
import SingleSelect from '@/components/shared/form/SingleSelect.vue';
import vInput from '@/components/shared/form/VerifiedInput.vue';
import vInputTel from '@/components/shared/form/VerifiedInputTel.vue';
import vTextArea from '@/components/shared/form/VerifiedTextArea.vue';
import vrfSelect from '@/components/shared/form/VerifiedSelect.vue';
import vrMultiSelect from '@/components/shared/form/VerifiedMultiSelect.vue';
import vrSingleSelect from '@/components/shared/form/VerifiedSingleSelect.vue';
import vMask from '@/components/shared/form/VerifiedMask.vue';
import VerifiedDatePicker from '@/components/shared/form/VerifiedDatePicker.vue';
import ModalContainer from '@/components/shared/ModalContainer.vue';
import EmptyTableMessage from '@/components/shared/tela/EmptyTableMessage.vue';
import AlertContainer from '@/components/shared/AlertContainer.vue';
import SearchBar from '@/components/shared/tela/SearchBar.vue';
// Loader geral
import Loader from '@/components/content/loader/Loader.vue';
// Loader geral - novo modelo
import Loading from '@/components/content/loader/Loading.vue';
// loader dentro do botão
import ButtonLoader from '@/components/shared/ButtonLoader.vue';
// Modal/sobre-página lateral
import LateralContent from '@/components/shared/tela/LateralContent.vue';
import AccessDenied from '@/components/shared/tela/AccessDenied.vue';
// Configuração de campos personalizáveis das tabelas
import ParametrizacaoCampoUsuario from '@/components/shared/tela/ParametrizacaoCampoUsuario.vue';
import PaginationViewer from '@/components/shared/tela/PaginationViewer.vue';

export const setComponents = (Vue) => {
    // importados
    Vue.component('vue-timepicker', VueTimepicker);
    Vue.component('v-draggable', draggable);
    Vue.component('v-select', vSelect);
    Vue.component('download-csv', JsonCSV);
    // locais
    Vue.component('v-money', vMoney);
    Vue.component('s-select', SingleSelect);
    Vue.component('v-input', vInput);
    Vue.component('v-input-tel', vInputTel);
    Vue.component('v-textarea', vTextArea);
    Vue.component('vs-select', vrfSelect);
    Vue.component('vms-select', vrMultiSelect);
    Vue.component('vss-select', vrSingleSelect);
    Vue.component('v-mask', vMask);
    Vue.component('verified-date-picker', VerifiedDatePicker);
    Vue.component('modal-container', ModalContainer);
    Vue.component('empty-table-message', EmptyTableMessage);
    Vue.component('alert-container', AlertContainer);
    Vue.component('search-bar', SearchBar);
    Vue.component('loader', Loader);
    Vue.component('loading', Loading);
    Vue.component('button-loader', ButtonLoader);
    Vue.component('lateral-content', LateralContent);
    Vue.component('access-denied', AccessDenied);
    Vue.component('parametrizacao-campos', ParametrizacaoCampoUsuario);
    Vue.component('PaginationViewer', PaginationViewer);
};
